import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase';
import { generateTeamName } from '../../../../../helpers/teamNameFormatter';

function SaveGeneratedTeams({hostcupId, roundId, draw, playersDraw, requestCount, setRequestCount}) {

    const [error, setError] = useState("");
    const [message, setMessage] = useState("")

    // ADD INDEX TO ARRAY
    const [playersArray, setPlayersArray] = useState([])

    const [round, setRound] = useState({})
    const [playersTeam, setPlayersTeam] = useState(5)
    const [numberOfTeams, setNumberOfTeams] = useState(8)

    useEffect(() => {

        try {
            const roundRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId);
            roundRef.onSnapshot(doc => {
                const round = {id: doc.id, ...doc.data()}
                setRound(round);
                setNumberOfTeams(round.num_teams)
                setPlayersTeam(round.players_per_team)
                console.log(round, "round fb")
            });
        } catch (error) {
            
        }

    }, [hostcupId, roundId])

    useEffect(() => {

        if (playersDraw && round) {

            console.log(round, "ROUND")

            
            const playersArray = playersDraw.map((player, index) => {
                let nameOfTeam
                const teamName = generateTeamName(index, numberOfTeams, playersTeam, playersDraw.length)
                teamName ? nameOfTeam = teamName : nameOfTeam = "A"
                return {...player, index: index, team_name: nameOfTeam}
            })
            console.log("TEAM SET", playersArray)
            setPlayersArray(playersArray)
        }

    }, [playersDraw, round])

    async function saveTeamHandler(e) {
        e.preventDefault();
        try {
            const teamsRoundRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("teams");
            if (!draw || !playersDraw) {
                setError("Trekning eller spillere ikke definert");
                return
            }
            const data = {
                teams: playersArray,
                draw: draw
            }
            console.log(data)
            teamsRoundRef.add(data);
            setMessage("Lag lagt til!");
            setRequestCount(requestCount+1);
        } catch (error) {
            setError("Kunne ikke lagre lag")
            console.log(error)
        }
    }

    return (
        <form onSubmit={saveTeamHandler}>
            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-success btn-block">Lagre trekt lag</button>
        </form>
    )

}
export default SaveGeneratedTeams